export function set3rdShare(config) {
  const { title, desc, imgUrl } = config;
  const metaTitle = document.createElement('meta');
  const metaDesc = document.createElement('meta');
  const metaImg = document.createElement('meta');
  metaTitle.setAttribute('property', 'og:title');
  metaDesc.setAttribute('property', 'og:description');
  metaImg.setAttribute('property', 'og:image');
  metaTitle.content = title;
  metaDesc.content = desc;
  metaImg.content = imgUrl;
  const headTag = document.getElementsByTagName('head')[0];
  headTag.appendChild(metaTitle);
  headTag.appendChild(metaDesc);
  headTag.appendChild(metaImg);
}
